<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}
  @if (!showFormLoader) {
<form #dataServiceForm="ngForm">
    <div class="fluid-container">
      <div class="form-group mt-3">
        <label>Property Name*</label>
        <input class="form-control" type="text" name="propertyName" [(ngModel)]="rowData.PROPERTY_NAME" required>
        @if (dataServiceForm.form?.get('propertyName')?.invalid && dataServiceForm.form?.get('propertyName')?.touched) {
<span class="form-error-container">
          Property name is required.
        </span>
}
      </div>
      <div class="form-group mt-3">
        <label>Property Value*</label>
        <input class="form-control" type="text" name="propertyValue" [(ngModel)]="rowData.PROPERTY_VALUE" required>
        @if (dataServiceForm.form?.get('propertyValue')?.invalid && dataServiceForm.form?.get('propertyValue')?.touched) {
<span class="form-error-container">
          Property value is required.
        </span>
}
      </div>
    </div>
  </form>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="saving" (click)="save()">
    @if (saving) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
